var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-option option",on:{"click":_vm.select}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }